/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ old: NonNullable<unknown>, new: NonNullable<unknown> }} Partner_Activity_PlanInputs */



/**
* | output |
* | --- |
* | "Plan {old} → {new}" |
*
* @param {Partner_Activity_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_plan = /** @type {((inputs: Partner_Activity_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tarif ${i?.old} → ${i?.new}`)
	return /** @type {LocalizedString} */ (`Plan ${i?.old} → ${i?.new}`)
});